<template>
<v-card color="grey lighten-4" flat>
    <v-toolbar color="primary" dark class="elevation-2" height="50px">
        <v-icon class="mr-3">mdi-chevron-down</v-icon>
        <v-toolbar-title>Liste des Intervention</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn v-if="isAuthorized( 'TrackingSheetConvention', 'update' )" icon color="green" @click.native="openEvent(0)"><v-icon>mdi-pencil-plus</v-icon></v-btn>
        <v-btn icon color="" @click.native="switchModal('specification', 0, 0, 1)"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>
    <v-card-text class="pa-3">
        <v-data-table :headers="headers" :items="items" :items-per-page="10" class="mt-2 elevation-1" >
            <template v-slot:[`item.eve_typ_id`]="{ item }">
                <v-chip label outlined>{{ typeState[item.eve_typ_id.substring(0, 3)][item.eve_typ_id].typ_name }}</v-chip>
            </template>
            <template v-slot:[`item.eve_sta_id`]="{ item }">
                <v-chip label outlined color="green">{{ stateState['GEN'][item.eve_sta_id].sta_label }}</v-chip>
            </template>
            <template v-slot:[`item.eve_date_start`]="{ item }">
                <v-chip label outlined>{{ locDateFormat.toLocale( item.eve_date_start ) }}</v-chip>
            </template>
            <template v-slot:[`item.eve_id`]="{ item }">
                <v-chip @click="openEvent(item.eve_id)" color="grey" label outlined><v-icon>mdi-pencil</v-icon></v-chip>
            </template>
            <template v-slot:no-data>
            <v-alert :value="( !loading.getEvent )" color="info" icon="mdi-information-outline">
                Aucune intervention
            </v-alert>
            </template>
        </v-data-table>
    </v-card-text>
    <v-card-actions style="background-color:white;">
    </v-card-actions>
    <v-dialog v-model="modalEvent" max-width="900" style="z-index:1056;">
        <v-card color="grey lighten-4" min-width="350px" flat >
        <v-toolbar color="primary" dark class="elevation-1" height="50px">
            <v-btn icon><v-icon>mdi-chevron-down</v-icon></v-btn>
            <v-toolbar-title>Action</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon color="" @click.native="switchModalEvent('modalEvent', 0)"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="mt-2">
            <edit-event class="elevation-2" 
                v-if="modalEvent" :switchModal="switchModalEvent"
                :xxxId="eve_xxx_id" :eveId="eveInfo.eve_id" :eveTable="'spf'">
            </edit-event>
        </v-card-text>
        </v-card>
    </v-dialog>        
</v-card>
</template>

<script>
import { cacheGetters } from "../store/cache.module"
import dateLocale from '../services/dateLocale';
import editEvent  from '../components/Edit_event.vue'
import { usrGetters }   from "../store/user.module"

export default {
    name: 'list_measure',
    props: ['switchModal', 'objTrackingSheet', 'spf_id'],
   data: function () {
        return {
            loading: { uploadBtn: false, rebuildBtn: false, getEvent: false },         // Enregistrement en cours...
            saveProgress: false,         // Enregistrement en cours...
            pagination: { totalItems: 0, rowsPerPage: 10, rowsPerItem: [15,25,35,{text:'Tout',value:-1}] },
            typeState: cacheGetters.getTypes(),
            stateState: cacheGetters.getStates(),
            headers: [
            { text: 'Titre', align: 'left', value: 'eve_typ_id'},
            { text: 'Description', align: 'left', value: 'eve_description'},
            { text: 'Date', align: 'left', value: 'eve_date_start'},
            { text: 'Statut', value: 'eve_sta_id' },
            { text: 'Intervention', value: 'eve_id' }
            ],
            items: [],
            locDateFormat: dateLocale,
            enableAdd: true,
            modalEvent : false,
            prv_id: 0,
            eve_id: 0,
            eve_xxx_id: 0,
            eveInfo: { eve_id: 0, eve_sta_id : 'MES01', eve_table_id: 'spf', eve_xxx_id  : this.spf_id },
            modalPagin : true,
            isAuthorized: usrGetters.getScopeRight,
        }
    },
    mounted: function (){
        this.getEvent()
    },
    methods: {
        getEvent(){
            this.items = []
            this.loading.getDocument = true
            var searchCriteria = '?per_page=false' //page='+ this.pagination.page +'&
            searchCriteria    += '&eve_xxx_id=' +  this.spf_id + '&eve_table_id=spf'
            //searchCriteria    += ( this.typfilter ) ? '&eve_typ_id=%' + this.typfilter + '%' : ''
            this.$http.get( '/events/' + searchCriteria ).then( (response) => {
                if( response.data.meta.total !== undefined && response.data.meta.total !== '0' ){
                    this.pagination.totalItems  = parseInt(response.data.meta.total)
                } else {
                    this.pagination.totalItems = 1
                }
                if( Object.prototype.toString.call( response.data.data ) === '[object Array]' ) {
                    this.items = response.data.data
                }
                this.loading.getEvent = false
            })
        },
        openEvent(id){
            this.eveInfo.eve_id = id
            this.eve_xxx_id     = this.spf_id
            this.switchModalEvent('modalEvent', 1)
        },
        openAssocModal(id){
            if( id !== undefined && id > 0 ){
                this.switchModalEvent('modalEvent', 1)
            }
        },
        switchModalEvent(name, mode, refresh){
            name    = name || 'modalEvent'
            mode    = mode || 0
            refresh = refresh || false
            this[name] = mode
            if( mode == 0 ){
                this.eve_xxx_id = 0
            }
            if( refresh ){ 
                this.getEvent()
            }
        }
    },
    components: {
        'edit-event'   : editEvent
    }
}
</script>